import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { MarketingLayout } from "@/components/MarketingLayout";
import client from "@/lib/api";

const iconFor = (name) => {
  const key = name.split("-").map((s) => s[0].toUpperCase() + s.slice(1)).join("");
  return Icons[key] || Icons.LayoutTemplate;
};

export default function TemplatesGallery() {
  const [templates, setTemplates] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    client.get("/templates").then(({ data }) => setTemplates(data)).catch(() => {});
  }, []);

  return (
    <MarketingLayout>
      <section className="mx-auto max-w-6xl px-6 pt-14 pb-4 text-center md:pt-20">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-ho-primary">Templates</span>
        <h1 className="font-display mx-auto mt-4 max-w-2xl text-4xl font-black tracking-tighter md:text-6xl">
          Start from something great
        </h1>
        <p className="mx-auto mt-5 max-w-lg text-lg text-ho-muted">
          Every template is a starting prompt, not a rigid layout. Pick one and make it yours in seconds.
        </p>
      </section>

      <section className="mx-auto max-w-6xl px-6 py-10">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {templates.map((t, i) => {
            const Icon = iconFor(t.icon);
            return (
              <motion.button key={t.id}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ delay: (i % 3) * 0.06, duration: 0.4 }}
                onClick={() => navigate("/login")}
                data-testid={`template-${t.id}`}
                className="tap-scale group overflow-hidden rounded-[28px] border border-black/5 bg-white text-left">
                <div className="relative h-40 overflow-hidden">
                  <img src={t.cover} alt={t.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute left-3 top-3 grid place-items-center w-10 h-10 rounded-2xl bg-white/90 backdrop-blur">
                    <Icon className="w-5 h-5 text-ho-primary" />
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center justify-between">
                    <h3 className="font-display text-lg font-bold">{t.name}</h3>
                    <ArrowRight className="w-4 h-4 text-ho-muted transition-transform group-hover:translate-x-1" />
                  </div>
                  <p className="mt-1 text-sm text-ho-muted">{t.tagline}</p>
                </div>
              </motion.button>
            );
          })}
        </div>
      </section>
    </MarketingLayout>
  );
}
